import { getLayoutObjFromName } from './getLayoutObjFromName';

export const getGutter = ({
  gridGutter,
  gridGutterTablet,
  gridGutterMobile,
  verticalMasonryGutter,
  verticalMasonryGutterTablet,
  verticalMasonryGutterMobile,
  horizontalMasonryGutter,
  horizontalMasonryGutterTablet,
  horizontalMasonryGutterMobile,
  panoramicGutter,
  panoramicGutterTablet,
  panoramicGutterMobile,
  layout
}) => {
  const { type, view, direction } = getLayoutObjFromName(layout);
  let result = null;

  if (type === 'masonry' && view === 'grid') {
    result = {
      default: gridGutter,
      tablet: gridGutterTablet,
      mobile: gridGutterMobile
    };
  } else if (
    type === 'masonry' &&
    view === 'masonry' &&
    direction === 'vertical'
  ) {
    result = {
      default: verticalMasonryGutter,
      tablet: verticalMasonryGutterTablet,
      mobile: verticalMasonryGutterMobile
    };
  } else if (
    type === 'masonry' &&
    view === 'masonry' &&
    direction === 'horizontal'
  ) {
    result = {
      default: horizontalMasonryGutter,
      tablet: horizontalMasonryGutterTablet,
      mobile: horizontalMasonryGutterMobile
    };
  } else if (type === 'panoramic') {
    result = {
      default: panoramicGutter,
      tablet: panoramicGutterTablet,
      mobile: panoramicGutterMobile
    };
  } else {
    result = {
      default: 0,
      tablet: 0,
      mobile: 0
    };
  }

  return result;
};
